'use client';

import { cn } from '@eliadmin/core/src/utils/style-utils';

export function ProductsSkeleton({
  amount = 4,
  className,
}: {
  amount?: number;
  className?: string;
}) {
  return (
    <div
      className={cn(
        'custom-container',
        'grid w-full grid-cols-1 gap-4 sm:grid-cols-2 sm:gap-5 lg:grid-cols-4 lg:gap-6',
        className,
      )}
    >
      {Array.from({ length: amount }).map((_, index) => (
        <ProductCardSkeleton key={index} />
      ))}
    </div>
  );
}

export function ProductCardSkeleton() {
  return <div className="col-span-1 h-[483px] w-full bg-neutral-100" />;
}
